export const TOGGLE_COLOR_MODE = 'TOGGLE_MODE'

export const toggle_theme = () => {
    return {
        type: TOGGLE_COLOR_MODE,
    }
}